/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PingOrderResponse
 */
export interface PingOrderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PingOrderResponse
     */
    completed?: boolean;
}

export function PingOrderResponseFromJSON(json: any): PingOrderResponse {
    return PingOrderResponseFromJSONTyped(json, false);
}

export function PingOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PingOrderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'completed': !exists(json, 'completed') ? undefined : json['completed'],
    };
}

export function PingOrderResponseToJSON(value?: PingOrderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'completed': value.completed,
    };
}


